import DefaultValidation from "@/services/validations/DefaultValidation";

export default class MotivoDespesasValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
            if(value!=null && typeof value == "string") model[key] = value.trim();
        });

        if (!model.descricao || model.qtdeminimafoto === '' ) {
            refs.descricaoInput.focusedOut = true;
            refs.qtdeMinFotoInput.focusedOut = true;
            validated = false;
        }
        
        if(model.datainicialauto == null && model.despesaautomatica==1){
            refs.datainicialauto.focusedOut = true;
            validated = false;
        }
        
        return validated;

    }
}